import { LocalizationApi, useAPIAction } from "melco-shared-logic";
//import { ALL_PUBLISHED_STATES } from "../../../helper/publishedState";

export const useDownloadLocaleStrings = (
  productCode: string,
  cultureCode: any
) => {
  return useAPIAction(
    LocalizationApi,
    async (api) => {
      const { raw } = await api.localizationExportRaw({
        moduleCode: productCode,
        cultureCode,
      });
      console.log();

      const blob = await raw.blob();
      const filename = raw.headers.get("x-filename") ?? undefined;

      console.log("Filename", filename);
      console.log("Blob", blob);
      let data = {
        blob,
        filename,
      };

      // console.log(y)
      return {
        successMessages: [],
        data,
      };
    },
    { translationPrefix: "global" }
  );
};
